// src/components/Layout/Footer.tsx
import React from 'react';
// import { useData } from '../../contexts/DataContext';

interface FooterProps {
  className?: string;
  showStats?: boolean;
}

const Footer: React.FC<FooterProps> = ({ 
  className = '',
  showStats = true 
}) => {
  // const { filteredData } = useData();
  const filteredData: any[] = []; // Fallback while DataContext is disabled
  
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className={`footer ${className}`}>
      <div className="container-fluid px-3">
        <div className="row">
          <div className="col-12 d-flex flex-column align-items-center justify-content-center h-100">
            {/* Footer text - centered and responsive */}
            <div className="footer-text text-center">
              <div className="footer-title">
                Regional Data Explorer © {currentYear} Università degli Studi Roma Tre
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;